import type {ListSuppliersSearch} from "./-types";

import {listSuppliersQueryOptions} from "@project/application/engineering/suppliers";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {SuppliersPage} from "./-page/suppliers.page";
import {SuppliersPending} from "./-page/suppliers.pending";
import {listSuppliersSearchSchema} from "./-types";

export type {ListSuppliersSearch} from "./-types";

export const Route = createFileRoute("/_app/engineering/suppliers/")({
  component: SuppliersPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(listSuppliersQueryOptions(deps as ListSuppliersSearch));
    }

    void queryClient.prefetchQuery(listSuppliersQueryOptions(deps as ListSuppliersSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: SuppliersPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listSuppliersSearchSchema.parse(search),
});
